// src/config.js
const config = {
  currentVersion: 'v2',
};

export default config;